export default __webpack_public_path__ + "static/media/CNo.73-1.45a5e4bf.jpg";